{
  "data.page.title": "{section} / Data",
  "data.section.projects": "Projects",
  "data.section.users": "Users",
  "data.section.organizations": "Organizations",
  "data.section.subscriptions": "Subscriptions",
  "data.section.plans": "Plans",
  "data.filter.all": "All",
  "data.filter.team": "Team · {count}",
  "data.filter.external": "External · {count}",
  "data.search.placeholder": "Search…",
  "data.action.reload": "Reload",
  "data.state.loadingAria": "Loading {section}…",
  "data.pagination.pageOf": "Page {page} of {total}",
  "data.pagination.page": "Page {page}",
  "data.pagination.prev": "← Prev",
  "data.pagination.next": "Next →",
  "data.empty.noMatches": "No matches",
  "data.empty.noData": "No data",
  "data.projects.col.name": "Name / Key",
  "data.projects.col.owner": "Owner",
  "data.projects.col.access": "Access",
  "data.projects.col.members": "Members",
  "data.projects.userCount": "{count} users",
  "data.projects.userCountOne": "1 user",
  "data.users.col.name": "Name",
  "data.users.col.email": "Email",
  "data.users.col.status": "Status",
  "data.users.col.provider": "Provider",
  "data.users.col.role": "Role",
  "data.users.badge.verified": "Verified",
  "data.users.badge.demoTitle": "Demo account",
  "data.users.badge.demo": "Demo",
  "data.organizations.col.name": "Name",
  "data.organizations.col.slug": "Slug",
  "data.organizations.col.owner": "Owner",
  "data.organizations.col.plans": "Plans",
  "data.organizations.col.projects": "Projects",
  "data.organizations.col.members": "Members",
  "data.organizations.memberCount": "{count} members",
  "data.organizations.memberCountOne": "1 member",
  "data.subscriptions.col.workspace": "Workspace",
  "data.subscriptions.col.organization": "Organization",
  "data.subscriptions.col.tier": "Tier",
  "data.subscriptions.col.credits": "Credits",
  "data.subscriptions.col.status": "Status",
  "data.plans.intro.live": "Live credit-tier model — api.symbols.app/core/credits/rates",
  "data.plans.intro.public": "Public plans & pricing from api.symbols.app",
  "data.plans.meter.heading": "How we charge",
  "data.plans.meter.modelMultipliers": "AI model multipliers",
  "data.plans.meter.infra": "Infrastructure",
  "data.plans.meter.comms": "Communications",
  "data.plans.meter.governance": "Governance & workflow",
  "data.plans.meter.empty": "No rates published",
  "data.plans.charging.title": "Charging model",
  "data.plans.charging.body": "Each workspace tier ships a monthly credit grant. Usage above the grant meters against the rate card below. Top up any amount from {min} at a flat {rate}/credit — no packs, no volume discount. Billing is per workspace — tier and grant attach to the workspace, not to individual projects.",
  "data.plans.charging.retail": "Retail price",
  "data.plans.charging.retailValue": "{rate} / credit",
  "data.plans.charging.topup": "Top-up",
  "data.plans.charging.topupValue": "From {min} · {rate}/credit flat",
  "data.plans.charging.topupValueMin": "From {min}",
  "data.plans.charging.topupHint": "Freeform amount, no packs",
  "data.plans.charging.scope": "Billing scope",
  "data.plans.charging.scopeValue": "Per workspace",
  "data.plans.charging.scopeHint": "Tier + grant per workspace, not per project",
  "data.plans.card.custom": "Custom",
  "data.plans.card.free": "Free",
  "data.plans.card.perMonth": "/ month",
  "data.plans.card.annualNote": "{price}/mo billed annually",
  "data.plans.card.trial": "{days}-day free trial",
  "data.plans.card.creditsCustom": "Custom credits",
  "data.plans.card.credits": "{credits} credits / mo",
  "data.plans.tier.rateLimit": "Rate limit",
  "data.plans.tier.rateLimitValue": "{count} req / min",
  "data.plans.tier.workspaces": "Workspaces",
  "data.plans.tier.projects": "Projects",
  "data.plans.tier.unlimited": "Unlimited",
  "data.plans.tier.environments": "Environments",
  "data.plans.tier.environmentsCustom": "{envs} + custom envs",
  "data.plans.tier.capabilities": "Capabilities",
  "data.plans.tier.capabilitiesValue": "{count} included",
  "data.plans.tier.support": "Support",
  "data.plans.option.popular": "Popular",
  "data.plans.limits.title": "Limits",
  "data.plans.limits.yes": "Yes",
  "data.plans.limits.no": "No",
  "data.plans.features.title": "Features ({count})",
  "data.plans.pricingOptions.title": "Pricing options ({count})",
  "data.rate.egressGb": "Egress / GB",
  "data.rate.storageGbMonth": "Storage / GB·mo",
  "data.rate.buildMinute": "Build / min",
  "data.rate.transcodeGb": "Transcode / GB",
  "data.rate.deploy": "Deploy",
  "data.rate.animationExport": "Animation export",
  "data.rate.templateInstallPremium": "Premium template install",
  "data.rate.brandbookPdf": "Brandbook PDF",
  "data.rate.callRelayPerParticipantMin": "Call relay / participant·min",
  "data.rate.liveCaptionsMin": "Live captions / min",
  "data.rate.postCallTranscriptMin": "Post-call transcript / min",
  "data.rate.recordingStorageGbMonth": "Recording storage / GB·mo",
  "data.rate.recordingTranscodeGb": "Recording transcode / GB",
  "data.rate.meetingSearchIndexingMin": "Meeting search indexing / min",
  "data.rate.esignature": "E-signature",
  "data.rate.voiceAgentMin": "Voice assistant call / min",
  "data.rate.policyEvalAboveFloor": "Policy eval (above floor)",
  "data.rate.policyEvalFreeFloorPerMo": "Policy eval free floor / mo",
  "data.rate.workflowRun": "Workflow run",
  "data.rate.auditRetentionGbMonthAboveFloor": "Audit retention / GB·mo (above floor)",
  "data.rate.auditRetentionFreeDays": "Audit retention free window",
  "data.rate.scimSyncPerUserMonthAboveFloor": "SCIM sync / user·mo (above floor)",
  "data.rate.scimSyncFreeUsers": "SCIM sync free users",
  "data.rate.webhookDeliveryPer1k": "Webhook delivery / 1K",
  "data.detail.kind.user": "USER",
  "data.detail.kind.plan": "PLAN",
  "data.detail.kind.organization": "ORGANIZATION",
  "data.detail.kind.subscription": "SUBSCRIPTION",
  "data.detail.kind.project": "PROJECT",
  "data.detail.saving": "Saving…",
  "data.detail.members.title": "Members ({count})",
  "data.detail.domains.title": "Domains ({count})",
  "data.detail.permissions.title": "Permissions",
  "data.detail.localProfile.title": "Local profile",
  "data.detail.localProfile.open": "Open profile →",
  "data.detail.openDirect": "Open direct",
  "data.detail.openPreview": "Open preview",
  "data.detail.openCanvas": "Open canvas",
  "data.detail.transfer.owner": "Owner: {owner}",
  "data.detail.transfer.confirmTitle": "Move “{project}” to “{org}”?",
  "data.detail.transfer.confirmMessage": "The project moves into this organization’s workspace. People who reach it only through its current owner, “{owner}”, lose access.",
  "data.detail.transfer.confirm": "Move project",
  "data.detail.transfer.failed": "Could not move the project: {error}",
  "data.external.page.title": "External data",
  "data.external.header.default": "External data",
  "data.external.header.workspaceData": "Workspace data",
  "data.external.header.rows": "{count} rows",
  "data.external.header.rowsCapped": "{count} rows · capped",
  "data.external.backToAdmin": "← Admin",
  "data.external.newRow": "+ New row",
  "data.external.refreshing": "Refreshing…",
  "data.external.retry": "Retry",
  "data.external.rail.loadingAria": "Loading sources",
  "data.external.rail.workspaceData": "Workspace data",
  "data.external.rail.collectionsEmpty": "No record collections yet — workspace apps create them as they store data.",
  "data.external.rail.backends": "Connected backends",
  "data.external.rail.backendsEmpty": "No backends connected to this workspace yet.",
  "data.external.rail.connectBackend": "+ Connect backend",
  "data.external.off.title": "External data is turned off",
  "data.external.off.hint": "Turn on the \"External sources\" flag (data.externalSources) to browse connected backends, workspace datasets, and their fetch wiring.",
  "data.external.off.cta": "Open feature flags →",
  "data.external.empty.title": "Pick a data source",
  "data.external.empty.collections": "{count} workspace collections",
  "data.external.empty.collectionsOne": "1 workspace collection",
  "data.external.empty.backends": "{count} connected backends",
  "data.external.empty.backendsOne": "1 connected backend",
  "data.external.empty.hint": "{collections} and {backends} in scope. Select one on the left to inspect its schema, browse rows, and copy its fetch wiring.",
  "data.external.empty.connectHint": "Configure backends in Admin → Integrations →",
  "data.external.dot.live": "Live — capability calls enabled",
  "data.external.dot.connected": "Connected",
  "data.external.integration.credentials": "credentials in vault",
  "data.external.integration.noCredentials": "no credentials",
  "data.external.caps.title": "Declared capabilities",
  "data.external.notice.comingSoon": "Connected — query engine coming soon. This backend declares data capabilities, but the server-side dispatcher for its kind is not implemented yet.",
  "data.external.notice.noDataset": "This integration does not expose a browsable dataset here — use its capabilities from your app via sdk.execute.",
  "data.external.runner.title": "Request runner",
  "data.external.runner.bodyPlaceholder": "{ \"json\": \"body\" } — sent as-is when not valid JSON",
  "data.external.runner.running": "Running…",
  "data.external.runner.run": "Run request",
  "data.external.runner.response": "Response · HTTP {status}",
  "data.external.rows.backToNamespaces": "← Namespaces",
  "data.external.rows.count": "{count} rows",
  "data.external.rows.countOne": "1 row",
  "data.external.rows.countMore": "{count} rows (showing the first pages)",
  "data.external.rows.countOneMore": "1 row (showing the first pages)",
  "data.external.schema.derived": "Schema · derived from rows",
  "data.external.schema.title": "Schema",
  "data.external.rows.emptyEditable": "No rows yet — create the first one with \"+ New row\".",
  "data.external.rows.empty": "No rows in this table.",
  "data.external.fetch.title": "Fetch wiring",
  "data.external.copy.done": "Snippet copied",
  "data.external.copy.failed": "Copy failed",
  "data.external.error.noResponse": "no response",
  "data.external.error.notSignedIn": "Not signed in — the session expired. Sign in again.",
  "data.external.error.notAllowed": "Not allowed — this capability needs an org owner/admin role (or a granted write role).",
  "data.external.error.notFound": "Integration not found — it may have been removed.",
  "data.external.error.httpStatus": "{error} (HTTP {status})",
  "data.external.error.unknownStatus": "with an error",
  "data.external.error.upstream": "Upstream responded {status}",
  "data.external.error.upstreamWithDetail": "Upstream responded {status} — {detail}",
  "data.external.error.integrationNotFound": "integration \"{slug}\" not found",
  "data.external.error.readOnly": "{kind} rows are read-only here",
  "data.external.error.notBrowsable": "{kind} rows are not browsable yet",
  "data.external.error.notANumber": "{field}: \"{value}\" is not a number",
  "data.external.error.invalidJson": "{field}: invalid JSON — {message}",
  "data.external.error.rowIdMissing": "row id missing",
  "data.external.error.noRoot": "no root state",
  "data.external.error.nothingToSave": "nothing to save",
  "data.external.error.saveInFlight": "save already in flight",
  "data.external.error.nothingToDelete": "nothing to delete",
  "data.external.snippet.recordsLabel": "Bind these rows declaratively",
  "data.external.snippet.recordsCaption": "Declare on any element — the @symbo.ls/fetch plugin routes it through the SDK adapter. Writes go through sdk.execute('workspaceProject.records', 'create' | 'update' | 'remove', { id, collection, data }).",
  "data.external.snippet.readTable": "Read {table} from your app",
  "data.external.snippet.callBackend": "Call this backend from your app",
  "data.external.snippet.listLabel": "List connected backends declaratively",
  "data.external.snippet.listCaption": "Declare on any element to bind the integration registry. {imperative}",
  "data.external.snippet.imperative": "Capability calls are imperative — route them through sdk.execute('orgIntegration', 'call', …) in a registered function; there is no declarative fetch for them.",
  "data.external.badge.live": "Live",
  "data.external.badge.connected": "Connected"
}
